import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header1.css';

const Header1 = () => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <header className="header1">
            <div className="logo" onClick={() => navigate('/')}>Digicard</div>

            {/* Burger icon */}
            <div className="burger" onClick={toggleMenu}>
                &#9776;
            </div>

            <nav className={`navigation ${menuOpen ? 'open' : ''}`}>
                <button onClick={() => navigate('/platform')}>Platform</button>
                <button onClick={() => navigate('/solutions')}>Solutions</button>
                <button onClick={() => navigate('/resources')}>Resources</button>
                <button onClick={() => navigate('/pricing')}>Pricing</button>
                <button onClick={() => navigate('/about')}>About Us</button>
                <button onClick={() => navigate('/contact')}>Contact Us</button>
                <button onClick={() => navigate('/cards')} className="sign-up">Create a Card</button>
                <button onClick={() => navigate('/login')} className="login">Login</button>
            </nav>
        </header>
    );
};

export default Header1;
